import {
  PartialQuestionnaire,
  QuestionnaireQuestions,
  Rule,
} from '../../models';

/**
 *
 * QNR-Framework helper functionality to find all dependents for a question.
 *
 */
export const findDependents = <
  Questionnaire extends QuestionnaireQuestions,
  GroupId,
  ExtendedComponentTypes
>(
  questionnaire: PartialQuestionnaire<
    Questionnaire,
    GroupId,
    ExtendedComponentTypes
  >,
  rules: Rule<Questionnaire>[],
  questionId: keyof Questionnaire
): (keyof Questionnaire)[] => {
  let path: (keyof Questionnaire)[] = [];
  for (const question of questionnaire) {
    if (!(question.id === questionId || path.includes(question.id))) {
      continue;
    }

    const questionRules = rules.filter((rule) => rule.id === question.id);
    if (questionRules.length === 0) {
      continue;
    }
    for (const rule of questionRules) {
      path.push(rule.then.goTo);
    }
  }

  return path;
};
